"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ErrorHandlingFormHelperText = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ErrorHandlingFormHelperText = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ErrorHandlingFormHelperText, _Component);

  var _super = _createSuper(ErrorHandlingFormHelperText);

  function ErrorHandlingFormHelperText() {
    var _this;

    (0, _classCallCheck2.default)(this, ErrorHandlingFormHelperText);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var muiFormControl = _this.context.muiFormControl;
      var _this$props = _this.props,
          id = _this$props.id,
          helperText = _this$props.helperText,
          errorMessage = _this$props.errorMessage;
      var _this$props2 = _this.props,
          error = _this$props2.error,
          disabled = _this$props2.disabled;

      if (muiFormControl) {
        if (muiFormControl.error !== undefined) {
          error = muiFormControl.error;
        }

        if (muiFormControl.disabled !== undefined) {
          disabled = muiFormControl.disabled;
        }
      }

      return helperText || error && errorMessage ? /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
        id: "".concat(id, "-helper-text"),
        error: error,
        disabled: disabled,
        className: "prmbl-errorHandlingFormHelperText"
      }, error ? errorMessage : helperText) : "";
    });
    return _this;
  }

  return ErrorHandlingFormHelperText;
}(_react.Component);

exports.ErrorHandlingFormHelperText = ErrorHandlingFormHelperText;
(0, _defineProperty2.default)(ErrorHandlingFormHelperText, "propTypes", {
  /**
   * If `true` the label, input, and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true` the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * The contents of the helper text when `error` is true
   */
  errorMessage: _propTypes.default.node,

  /**
   * The contents of the helper text when `error` is false
   */
  helperText: _propTypes.default.node,

  /**
   * The html id
   */
  id: _propTypes.default.string
});
(0, _defineProperty2.default)(ErrorHandlingFormHelperText, "contextTypes", {
  muiFormControl: _propTypes.default.object
});
var _default = ErrorHandlingFormHelperText;
exports.default = _default;